import React from 'react';
import { render } from 'react-dom';

import { RadianceThemeProvider } from 'jsx/components/radianceThemeProvider';

import DevLanding from './app';

render(
  <RadianceThemeProvider>
    <DevLanding />
  </RadianceThemeProvider>,
  document.getElementById('main-content'),
);
